import { defineAsyncComponent } from 'vue'
export default {
  "checkout-express": defineAsyncComponent(() => import("/usr/src/app/apps/site-sk/app/layouts/checkout-express.vue").then(m => m.default || m)),
  checkout: defineAsyncComponent(() => import("/usr/src/app/apps/site-sk/app/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/usr/src/app/apps/site-sk/app/layouts/default.vue").then(m => m.default || m)),
  "no-vuetify": defineAsyncComponent(() => import("/usr/src/app/apps/site-sk/app/layouts/no-vuetify.vue").then(m => m.default || m)),
  plain: defineAsyncComponent(() => import("/usr/src/app/apps/site-sk/app/layouts/plain.vue").then(m => m.default || m))
}